export default __webpack_public_path__ + "images/02889948dc59947db88516c34f315fa5-career.jpg";